import {
  ItemGroup,
  ItemGroupPageQuery,
  ItemGroupResource,
  ItemGroupResourcePage,
  ItemGroupResourcePayload,
  PageOf
} from '@/models'

import {
  generateCreate,
  generateDelete,
  generateRead,
  generateReadPage,
  generateUpdate,
  generateUpdateImage
} from '../crudGenerator'

/**
 * Converts ItemGroupResource to ItemGroup.
 *
 * @param resource Reponse data to be converted.
 */
export function parseItemGroupResource (resource: ItemGroupResource): ItemGroup {
  return {
    id: resource.id,
    title: resource.title,
    imageId: resource.imageId,
    updatedAt: new Date(resource.updatedAt),
    isActive: resource.active // Renaming
  }
}

/**
 * Converts ItemGroupResourcePage to PageOf<ItemGroup>.
 *
 * @param resource Reponse data to be converted.
 */
export function parseItemGroupResourcePage (page: ItemGroupResourcePage): PageOf<ItemGroup> {
  return {
    elements: page.itemGroups.map(parseItemGroupResource),
    total: page.count
  }
}

const url = '/menu'
const entity = 'item-groups'

export default {
  /**
   * Creates a new ItemGroup.
   *
   * @param tokenV2 Valid token with an AccountId.
   * @param payload Data required to create it.
   */
  createItemGroup: generateCreate<ItemGroup, ItemGroupResource, ItemGroupResourcePayload>(url, entity, parseItemGroupResource),

  /**
   * Deletes an ItemGroup.
   *
   * @param tokenV2 Valid token with an AccountId.
   * @param id ItemGroup id to be deleted.
   */
  deleteItemGroup: generateDelete(url, entity),

  /**
   * Gets an ItemGroup.
   *
   * @param tokenV2 Valid token with an AccountId.
   * @param id ItemGroup id to be fetched.
   */
  fetchItemGroup: generateRead(url, entity, parseItemGroupResource),

  /**
   * Gets a page of ItemGroups.
   *
   * @param tokenV2 Valid token with an AccountId.
   * @param query Query options.
   */
  fetchItemGroupPage: generateReadPage<ItemGroup, ItemGroupResourcePage, ItemGroupPageQuery>(url, entity, parseItemGroupResourcePage),

  /**
   * Updates an existing ItemGroup.
   *
   * @param tokenV2 Valid token with an AccountId.
   * @param id ItemGroup id to be updated.
   * @param payload Data required to create it.
   */
  updateItemGroup: generateUpdate<ItemGroup, ItemGroupResource, ItemGroupResourcePayload>(url, entity, parseItemGroupResource),

  /**
   * Updates the image for an ItemGroup.
   *
   * @param tokenV2 Valid token with an AccountId.
   * @param id ItemGroup id whose image will be updated.
   * @param formData Form with file to be uploaded.
   */
  updateItemGroupImage: generateUpdateImage(url, entity, parseItemGroupResource)
}
